import { all, call, put, select, takeLatest } from "redux-saga/effects";
import db from "../../common/lib/database";
import actions from "../actions";
import { actionCreators, actionTypes } from "./actions";
import { get, update } from "idb-keyval";
import { logToSentry } from "../../config/Sentry";

function* selectAssetAuditors(action) {
    const { assignments } = action.payload;
    try {
        let assetAuditors = yield call(get, db.types.assetAuditor);

        if (assetAuditors)
            assetAuditors = assetAuditors.filter((item) =>
                assignments.includes(item.auditAssignment.id)
            );

        yield put(actionCreators.selectSuccess(assetAuditors));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("asset auditor select", {
            error,
            errStr,
            actionPayload: action.payload,
        });

        yield put(actionCreators.selectFailure(errStr));
    }
}

function* getItemAssetAuditor(action) {
    const { auditId, assetId } = action.payload;
    try {
        let results = (yield call(get, db.types.assetAuditor)) || [];
        const next = results.find(
            (item) =>
                item.auditAssignment.auditLocation.audit.id ===
                    parseInt(auditId) &&
                item.auditAsset.id === parseInt(assetId)
        );
        yield put(actionCreators.getSuccess(next));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("get item asset auditor", {
            error,
            errStr,
            actionPayload: action.payload,
        });
        yield put(actionCreators.getFailure(errStr));
    }
}

function* writeAssetAuditors(action) {
    const { assetAuditors, status } = action.payload;
    try {
        yield call(update, db.types.assetAuditor, (assetAuditorDB = []) => {
            if (!assetAuditorDB) assetAuditorDB = [];
            assetAuditorDB.map((item) => {
                if (assetAuditors[0].auditAsset.id === item.auditAsset.id) {
                    item.auditAssignment = assetAuditors[0].auditAssignment;
                }
            });

            return [...assetAuditorDB, ...assetAuditors];
        });

        // /** Update auditAsset db with isAssigned = true */

        const assetIds = assetAuditors.map((item) => item.auditAsset.id);

        yield call(update, db.types.auditAsset, (updatedAssetsDB = []) => {
            if (!updatedAssetsDB) updatedAssetsDB = [];
            const updatedAssets = updatedAssetsDB.map((obj) => {
                if (assetIds.includes(obj.id)) {
                    obj.isAssigned = true;
                    obj["status"] = status;
                }
                return obj;
            });
            return updatedAssets;
        });

        // // update auditAssets store
        yield put(actions.auditAssets.create.setAssetAssigned(assetIds));
        yield put(actionCreators.writeSuccess());
    } catch (error) {
        const errStr = error.toString();
        logToSentry("asset auditor write", {
            error,
            errStr,
            actionPayload: action.payload,
        });
        yield put(actionCreators.writeFailure(errStr));
    }
}

function* updateAssetAuditors(action) {
    const { assetStatus, images, note } = action.payload.assetAuditor;

    try {
        const { assetAuditors, audits } = yield select((state) => state);
        const auditId = audits && audits.item.id;
        const assetId = assetAuditors && assetAuditors.item.auditAsset.id;
        yield call(update, db.types.assetAuditor, (updatedAssetsDB = []) => {
            if (!updatedAssetsDB) updatedAssetsDB = [];
            const updatedAssets = updatedAssetsDB.map((item) => {
                if (
                    item.auditAssignment.auditLocation.audit.id === auditId &&
                    item.auditAsset.id === assetId
                ) {
                    item.notes =
                        note.content.length > 0
                            ? item.notes.concat(note)
                            : item.notes;
                    item.auditImages =
                        images.length > 0
                            ? item.auditImages.concat(images)
                            : item.auditImages;
                }
                return item;
            });
            return updatedAssets;
        });
        yield put(actionCreators.updateSuccess());
    } catch (error) {
        const errStr = error.toString();
        logToSentry("asset auditor update", {
            error,
            errStr,
            actionPayload: action.payload,
        });
        yield put(actionCreators.updateFailure(errStr));
    }
}

// for testing
export {
    selectAssetAuditors,
    writeAssetAuditors,
    getItemAssetAuditor,
    updateAssetAuditors,
};

export default (function* () {
    yield all([
        takeLatest(
            actionTypes.ASSET_AUDITORS_SELECT_REQUEST,
            selectAssetAuditors
        ),
        takeLatest(
            actionTypes.ASSET_AUDITORS_WRITE_REQUEST,
            writeAssetAuditors
        ),
        takeLatest(
            actionTypes.ASSET_AUDITORS_GET_ITEM_REQUEST,
            getItemAssetAuditor
        ),
        takeLatest(
            actionTypes.ASSET_AUDITORS_UPDATE_REQUEST,
            updateAssetAuditors
        ),
    ]);
})();

/**
 * 1. Update used for the future purpose
 */
